import { Card } from "antd";
import React from "react";

const AnalyticsCard = ({ children }) => {
  return (
    <div>
      <Card
        style={{
          width: "100%",
          borderRadius: "12px",
          border: "2px solid #EEE",
          padding: "0",
          minHeight:'100px'
        }}
        className="single-card"
        bodyStyle={{
          padding: "16px",
        }}
      >
        {children}  
      </Card>
    </div>
  );
};

export default AnalyticsCard;
